// Mai multe sectiuni de pe aceeasi pagina pot include acest fisier (imaginea
// mare, sectiunea cu imagine si text, galeria de idei de cadouri...). Browserul
// executa scriptul o data pentru fiecare, iar o clasa declarata direct in
// document ar fi declarata de doua ori si ar arunca SyntaxError, oprind restul
// executiei. Invelisul o tine locala, iar verificarea de la inceput face ca
// executiile urmatoare sa nu mai faca nimic.
(() => {
  if (customElements.get('services-modal')) return;

  class ServicesModal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || this.initialized) return;
      this.initialized = true;

      this.openers = document.querySelectorAll(`[data-services-modal-open="${this.id}"]`);
      this.openers.forEach((opener) => {
        opener.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        });
      });

      this.querySelectorAll('[data-services-modal-close]').forEach((closer) => {
        closer.addEventListener('click', () => this.dialog.close());
      });

      // Click pe fundal (în afara conținutului) închide dialogul.
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });

      this.dialog.addEventListener('close', () => {
        document.body.classList.remove('overflow-hidden');
      });

      // Formularul Shopify face redirect după trimitere; redeschidem modalul
      // ca să fie vizibil mesajul de succes.
      if (this.querySelector('[data-services-modal-success]')) this.open();
      // Validarea inline a campurilor (nume/email/telefon/suma) e gestionata global
      // de contact-form-validation.js pentru toate formularele de contact.
    }

    disconnectedCallback() {
      document.body.classList.remove('overflow-hidden');
    }

    open() {
      if (!this.dialog.open) this.dialog.showModal();
      document.body.classList.add('overflow-hidden');
      const focusTarget = this.dialog.querySelector('[data-services-modal-success], input, select, textarea');
      if (focusTarget) focusTarget.focus();
    }
  }

  if (!customElements.get('services-modal')) {
    customElements.define('services-modal', ServicesModal);
  }
})();
